var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons-RZ_Blau",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#92bcbf;}.cls-2{fill:#223656;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 25,
    r: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.02,32.45c1.09,0,1.98-.89,1.98-1.98V14.1c0-1.09-.89-1.98-1.98-1.98h-.24s-25.79,0-25.79,0c-1.09,0-1.98,.89-1.98,1.98V30.47c0,1.09,.89,1.98,1.98,1.98h2.41v4.93c0,.2,.12,.39,.31,.47,.19,.08,.41,.03,.55-.11l5.29-5.29h17.48Zm-18.04-.86l-4.57,4.57v-4.22c0-.28-.23-.5-.51-.5h-2.91c-.54,0-.97-.44-.97-.97V14.1c0-.54,.44-.97,.97-.97h26.03c.54,0,.97,.44,.97,.97V30.47c0,.54-.44,.97-.97,.97H20.33c-.13,0-.26,.05-.36,.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.18,28.38l1.2-.66c.37-.2,.82-.2,1.19,0l1.2,.66c.4,.22,.9,.2,1.28-.05l1.27-.84c.61-.41,.98-1.09,.98-1.82h0c0-.64-.28-1.25-.77-1.67l-3.76-3.18c-.46-.39-1.14-.39-1.6,0l-3.76,3.18c-.49,.42-.77,1.02-.77,1.67h0c0,.73,.37,1.42,.98,1.82l1.27,.84c.38,.25,.88,.27,1.28,.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 20.19,
    cy: 21.08,
    rx: 1.39,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 29.77,
    cy: 21.08,
    rx: 1.39,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.95,19.8c.89,0,1.61-.81,1.61-1.82s-.72-1.82-1.61-1.82-1.61,.81-1.61,1.82,.72,1.82,1.61,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.98,19.8c.89,0,1.61-.81,1.61-1.82s-.72-1.82-1.61-1.82-1.61,.81-1.61,1.82,.72,1.82,1.61,1.82Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.cda1a9224aa75b01750150058ee2e7fd.svg";
export { ForwardRef as ReactComponent };